import React from 'react';
import { Database, CalendarDays, BarChart2, GitBranch } from 'lucide-react';

const ProjectParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  projectTypes 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Объем данных */}
      <div>
        <label htmlFor="dataVolume" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Database className="w-4 h-4 mr-2 text-indigo-500" />
          Объем данных
        </label>
        <div className="flex">
          <input
            type="text"
            id="dataVolume"
            name="dataVolume"
            value={formData.dataVolume}
            onChange={handleInputChange}
            className={`form-input w-full rounded-r-none ${errors.dataVolume ? 'input-error' : ''}`}
            placeholder="Объем"
          />
          <select
            name="dataVolumeUnit"
            value={formData.dataVolumeUnit}
            onChange={handleInputChange}
            className={`form-select w-1/3 rounded-l-none ${errors.dataVolumeUnit ? 'input-error' : ''}`}
          >
            <option value="gb">GB</option>
            <option value="tb">TB</option>
            <option value="pb">PB</option>
          </select>
        </div>
        {errors.dataVolume && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.dataVolume}
          </p>
        )}
        {errors.dataVolumeUnit && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.dataVolumeUnit}
          </p>
        )}
      </div>

      {/* Скорость обработки */}
      <div>
        <label htmlFor="dataProcessingRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <BarChart2 className="w-4 h-4 mr-2 text-indigo-500" />
          Скорость обработки (ГБ/час)
        </label>
        <input
          type="text"
          id="dataProcessingRate"
          name="dataProcessingRate"
          value={formData.dataProcessingRate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.dataProcessingRate ? 'input-error' : ''}`}
          placeholder="Скорость обработки"
        />
        {errors.dataProcessingRate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.dataProcessingRate}
          </p>
        )}
      </div>

      {/* Срок проекта */}
      <div>
        <label htmlFor="projectDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <CalendarDays className="w-4 h-4 mr-2 text-indigo-500" />
          Срок проекта (месяцев)
        </label>
        <input
          type="text"
          id="projectDuration"
          name="projectDuration"
          value={formData.projectDuration}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.projectDuration ? 'input-error' : ''}`}
          placeholder="Длительность проекта"
        />
        {errors.projectDuration && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.projectDuration}
          </p>
        )}
      </div>

      {/* Количество источников данных */}
      <div>
        <label htmlFor="dataSourcesCount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <GitBranch className="w-4 h-4 mr-2 text-indigo-500" />
          Количество источников данных
        </label>
        <input
          type="text"
          id="dataSourcesCount"
          name="dataSourcesCount"
          value={formData.dataSourcesCount}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.dataSourcesCount ? 'input-error' : ''}`}
          placeholder="Количество источников"
        />
        {errors.dataSourcesCount && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.dataSourcesCount}
          </p>
        )}
      </div>

      {/* Тип проекта */}
      <div className="md:col-span-2">
        <label htmlFor="projectType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Тип проекта
        </label>
        <select
          id="projectType"
          name="projectType"
          value={formData.projectType}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.projectType ? 'input-error' : ''}`}
        >
          {projectTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
        {errors.projectType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.projectType}
          </p>
        )}
        {formData.projectType && (
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            {projectTypes.find(t => t.id === formData.projectType)?.description || ''}
          </p>
        )}
      </div>

      {/* Размер команды */}
      <div>
        <label htmlFor="teamSize" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Размер команды (человек)
        </label>
        <input
          type="text"
          id="teamSize"
          name="teamSize"
          value={formData.teamSize}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.teamSize ? 'input-error' : ''}`}
          placeholder="Количество людей в команде"
        />
        {errors.teamSize && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.teamSize}
          </p>
        )}
      </div>

      {/* Непредвиденные расходы */}
      <div>
        <label htmlFor="contingencyPercent" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Непредвиденные расходы (%)
        </label>
        <input
          type="text"
          id="contingencyPercent"
          name="contingencyPercent"
          value={formData.contingencyPercent}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.contingencyPercent ? 'input-error' : ''}`}
          placeholder="Процент на непредвиденные расходы"
        />
        {errors.contingencyPercent && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.contingencyPercent}
          </p>
        )}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Резерв на покрытие непредвиденных расходов и рисков проекта
        </p>
      </div>
      
      {/* Валюта */}
      <div className="md:col-span-2">
        <label htmlFor="currency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Валюта расчета
        </label>
        <select
          id="currency"
          name="currency"
          value={formData.currency}
          onChange={handleInputChange}
          className={`form-select w-full md:w-1/3 ${errors.currency ? 'input-error' : ''}`}
        >
          <option value="usd">USD (Доллар США)</option>
          <option value="eur">EUR (Евро)</option>
          <option value="rub">RUB (Российский рубль)</option>
          <option value="gbp">GBP (Фунт стерлингов)</option>
        </select>
        {errors.currency && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.currency}
          </p>
        )}
      </div>
    </div>
  );
};

export default ProjectParametersSection;